import React, { useRef, useState } from 'react';
import useClickOutside from '../../../hooks/useClickOutside';
import AttendanceSelectBox from './selectbox/PromptAttendanceSelectBox';
import TimeSelectBox from './selectbox/PromptTimeSelectBox';
import Image from '../../../components/image/Image';
import * as S from '../promptAttendanceTable/PromptAttendanceTable.style';

const PromptAttendanceTableInfo = ({
	value,
	attendance,
	date,
	setUser,
	index,
	isSelected,
	onToggleSelect,
}) => {
	const [attendanceClick, setAttendanceClick] = useState(false);
	const [startTimeClick, setStartTimeClick] = useState(false);
	const [endTimeClick, setEndTimeClick] = useState(false);

	const attendanceRef = useRef(null);
	const startTimeRef = useRef(null);
	const endTimeRef = useRef(null);

	useClickOutside({
		elementRef: attendanceRef,
		stateVariable: attendanceClick,
		stateFunction: () => setAttendanceClick(false),
	});

	useClickOutside({
		elementRef: startTimeRef,
		stateVariable: startTimeClick,
		stateFunction: () => setStartTimeClick(false),
	});

	useClickOutside({
		elementRef: endTimeRef,
		stateVariable: endTimeClick,
		stateFunction: () => setEndTimeClick(false),
	});

	const age = () => {
		const birth = value.birth.toString();
		const year = birth.substring(0, 4);
		const month = birth.substring(4, 6) - 1;
		const day = birth.substring(6, 8);
		const birthDate = new Date(year, month, day);
		const currentDate = new Date();

		let currentAge = currentDate.getFullYear() - birthDate.getFullYear();

		if (
			currentDate.getMonth() < birthDate.getMonth() ||
			(currentDate.getMonth() === birthDate.getMonth() &&
				currentDate.getDate() < birthDate.getDate())
		) {
			currentAge--;
		}

		return currentAge;
	};

	return (
		<tr key={`${value.name}_${value.kidId}`}>
			<td className='index'>
				<input
					type='checkbox'
					checked={!!isSelected}
					onChange={onToggleSelect}
				/>
			</td>
			<td className='index'>{index + 1}</td>
			<td>{value.name}</td>
			<td>{age()}</td>
			<td>{value.profile?.name}</td>
			<td className='select'>
				<div className='box' ref={attendanceRef}>
					<AttendanceSelectBox
						click={attendanceClick}
						onClick={() => setAttendanceClick(!attendanceClick)}
						initValue={value.state}
						options={attendance}
						date={date}
						user={value}
					/>
				</div>
			</td>
			<td
				className={`select start ${
					value?.state === 'ABSENCE' ? 'absence' : ''
				}`}>
				<div className='box' ref={startTimeRef}>
					<TimeSelectBox
						click={startTimeClick}
						onClick={() => setStartTimeClick(!startTimeClick)}
						user={value}
						date={date}
						time={value.startTime}
						type='start'
					/>
				</div>
			</td>
			<td
				className={`select end ${value?.state === 'ABSENCE' ? 'absence' : ''}`}>
				<div className='box' ref={endTimeRef}>
					<TimeSelectBox
						click={endTimeClick}
						onClick={() => setEndTimeClick(!endTimeClick)}
						user={value}
						date={date}
						time={value.endTime}
						type='end'
					/>
				</div>
			</td>
			<td className='deco'></td>
			<td>
				<button
					className='setButton'
					onClick={() => setUser({ type: 'change', value })}>
					<Image srcArray={S.profile_list} />
					<p>친구 관리</p>
				</button>
			</td>
		</tr>
	);
};

export default PromptAttendanceTableInfo;
